import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Location } from '@angular/common';
import { ThemeToggleComponent } from '../theme-toggle/theme-toggle.component';

@Component({
    selector: 'app-auth-header',
    standalone: true,
    imports: [CommonModule, ThemeToggleComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './app-auth-header.html'
})
export class AppAuthHeader {
    @Input() showBack: boolean = false;

    constructor(private location: Location) { }

    goBack() {
        this.location.back();
    }
}
